import { printAST } from '../core.print-ast.js';
import '@utils/constants';
import { xml2ast } from '../xml2ast/core.xml2ast.js';
import { allHtmlParsers } from '../xml2ast/parsers/common.html.js';
import { htmlNodeToTextPrinter } from './common.html.js';
import { textNodeToTextPrinter } from './common.text.js';

const basePrinters = {
  html: htmlNodeToTextPrinter,
  text: textNodeToTextPrinter
};
function printHtmlNodesToText(ast) {
  return printAST(ast, basePrinters).join("");
}
function printHtmlToText(html, parsers = allHtmlParsers) {
  return printHtmlNodesToText(xml2ast(html, parsers, "text/html"));
}

export { htmlNodeToTextPrinter, printHtmlNodesToText, printHtmlToText, textNodeToTextPrinter };
//# sourceMappingURL=index.js.map
